import dynamic from 'next/dynamic';
import { ComponentConfig } from '@zapier/builder-io-kit-compat';

export const config: ComponentConfig = {
  name: 'Button',
  description:
    'Classic button component. Use when providing calls to action to users.',
  category: 'Zapier Sign Up Blocks',
  // @ts-ignore
  component: dynamic(() =>
    import('@zapier/design-system').then(mod => mod.Button)
  ),
  inputs: [
    {
      name: 'children',
      friendlyName: 'Label',
      type: 'string',
      defaultValue: 'Go',
      helperText: 'Text that describes the action the button will take.',
    },
    {
      name: 'color',
      friendlyName: 'Color',
      type: 'string',
      defaultValue: 'primary',
      enum: [
        { label: 'Primary', value: 'primary' },
        { label: 'Secondary', value: 'secondary' },
      ],
      helperText: 'The color style to render for Button',
    },
  ],
};
